import API from "../Utils/API";

export const getSiteVisiteDetails = (lead_id) => (dispatch) => {
  dispatch({ type: "GET_SITE_VISIT_DETAILS_REQUEST" });
  API.get(`/site_visit_details?lead_id=${lead_id}`)
    .then((response) => {
      dispatch({
        type: "GET_SITE_VISIT_DETAILS_SUCCESS",
        payload: response?.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: "GET_SITE_VISIT_DETAILS_FAILURE",
        payload: error.response?.data,
      });
    });
};

export const createSiteVisitDetails = (data, successCallback) => (dispatch) => {
  dispatch({ type: "CREATE_SITE_VISIT_DETAILS_REQUEST", payload: data });
  API.post("/site_visit_details", data)
    .then((response) => {
      dispatch({
        type: "CREATE_SITE_VISIT_DETAILS_SUCCESS",
        payload: response,
      });
      if (successCallback) successCallback(response?.data);
    //   dispatch(getAllTasks(data.attachment_id));
    })
    .catch((error) => {
      dispatch({
        type: "CREATE_SITE_VISIT_DETAILS_FAILURE",
        payload: error.response?.data,
      });
    });
};
